import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import '../../../src/scss/pages/_page-title.scss'
import { RangeDatePicker, DatePicker } from "@y0c/react-datepicker";
import { useEffect } from "react";
import { useHistory } from 'react-router-dom';

const PageTitle = ({ title, subtitle }) => {

	const history = useHistory();

	const [modalCentered, setModalCentered] = useState(false);
	const [pathState, setPathState] = useState("");
	const handleClose = () => setModalCentered(false)

	const location = useLocation();

	let path = location.pathname.split("/");

	let path1 = path[path.length - 1];

	let report = [
		"report"
	]


	useEffect(() => {
		if (location.pathname === "/order") {
			setPathState("order")
			console.log(pathState);
		} else if ((path.length == 4) && (report.includes(path1))) {
			setPathState("backicon")
		} else if (location.pathname === "/notificationcenter" || location.pathname === "/university" || location.pathname === "/growthcenter") {
			setPathState("restuarant")
		} else if (location.pathname === "/vendorperformance") {
			setPathState("vendor")
		} else if (location.pathname === "/invoices") {
			setPathState("invoice")
		}
	}, [location.pathname,!pathState])


	return (
		<div>
			<div className='row w-100 m-0'>
				<div className='col-md-4 col-lg-4'>
					<h4 className='card-title'> {pathState === "backicon" && <span onClick={history.goBack}><i class="bi bi-arrow-left me-1" style={{ cursor: 'pointer' }}></i> </span>} {title}</h4>
					<span style={{ marginLeft: pathState === "backicon" && '27px' }}  >{subtitle}</span>
				</div>
				<div className='col-md-8 col-lg-8 pe-0'>
					<div className="row d-flex justify-content-end">
						<div className="col-md-4 col-lg-4 d-flex justify-content-end">
							{
								pathState === "order" || pathState === "vendor" ?
								<ul>
									<li>Timeframe</li>
									<li className='mt-1'>
										<div className="d-flex flex-row timeframe">
											<div class="form-check">
												<input class="form-check-input" type="radio" name="flexRadioDefault" id="today" />
												<label class="form-check-label" htmlFor='today'>
													Today
												</label>
											</div>
											<div class="form-check">
												<input class="form-check-input" type="radio" name="flexRadioDefault" id="yesterday" />
												<label class="form-check-label" htmlFor='yesterday'>
													Yesterday
												</label>
											</div>
											<div onClick={() => setModalCentered(true)} className='border-left d-flex justify-content-center align-items-center'>
												<i class="bi bi-three-dots-vertical px-2 fw-bold" style={{ cursor: 'pointer' }}></i>
											</div>
										</div>

										<Modal className="fade" centered onHide={handleClose} show={modalCentered}>

											<Modal.Body>
												<h5>Date selector</h5>
												<p>
													Select a custom time frame
												</p>

												<RangeDatePicker
													startText="Start"
													endText="End"
													startPlaceholder="Start Date"
													endPlaceholder="End Date"
												/>
											</Modal.Body>
											<div className='d-flex justify-content-end p-4'>
												<Button variant="info" className="me-3">Cancel</Button>
												<Button variant="primary">Apply</Button>
											</div>
										</Modal>
									</li>
								</ul>:""
							}
						</div>
						{pathState != "restuarant" &&
							<div className="col-md-4 col-lg-4 d-flex justify-content-end">
								<ul>
									<li>Vendor</li>
									<li className='mt-1'>
										<select style={{ width: '123px' }}>
											<option> All (2/2)</option>
											<option>(1/2)</option>
											<option>(1/1)</option>
										</select>
									</li>
								</ul>
							</div>
						}
					</div>
				</div>
			</div>
			<hr />
		</div>
	);
};

export default PageTitle;
